module.exports = __webpack_public_path__ + "static/media/floodinsurencepennymac.13f23543.svg";